import {
  ADD_CASES,
  GET_CASES,
  GET_CASEID,
  GET_CASEDETAILSBYID,
  UPDATE_CASES,
  UNLOCK_CASES,
  LOCK_CASES,
  GET_ADMIN_CASES,
  GET_NEW_CASES,
  UPDATE_CASES_DISPLAYNAME,
  GET_SUBMIT_CASES,
  PERMITDUPLICATECHECK,
  GET_MIGRATE_CASES,
  GET_PERMISSION_CASES,
  ADMIN_CASE_TIMEINFO,
  GET_CASETIME_INFO_BY_ID,
  CLEAR_CASE_TIME_INFO,
} from '../types'

const INITIAL_STATE = {
  caseId: '',
  addCase: [],
  allFormsByCaseId: [],
  allCases: [],
  editCases: [],
  lockcases: [],
  getAllAdmin: [],
  permitDuplicate: { permission: null },
  permitSubmission: { permission: null },
  permitNewCase: {},
  // permitDuplicate: {},
  allMigrateCase: [],
  permissionCases: [],
  adminCaseTimeInfo: {},
  getCaseTimeInfo: [],
  total_records: null,
}

const casesReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_CASEID:
      return {
        ...state,
        caseId: payload?.data,
      }
    case ADD_CASES:
      return {
        ...state,
        addCase: payload,
        caseId: payload.displayName,
      }
    case UPDATE_CASES_DISPLAYNAME:
      return {
        ...state,
        addCase: payload,
        caseId: payload.displayName,
      }
    case GET_MIGRATE_CASES:
      return {
        ...state,
        allMigrateCase: payload.data,
      }
    case GET_CASEDETAILSBYID:
      return {
        ...state,
        allFormsByCaseId: payload.data,
      }
    case GET_CASES:
      return {
        ...state,
        allCases: {
          ...state.allCases,
          ...payload, 
          create: payload.create,
        },
      }
    case UPDATE_CASES:
      return {
        ...state,
        editCases: payload.data,
      }
    case UNLOCK_CASES:
      return {
        ...state,
        lockcases: payload.data,
      }
    case LOCK_CASES:
      return {
        ...state,
        lockcases: payload.data,
      }
    case GET_ADMIN_CASES:
      return {
        ...state,
        getAllAdmin: payload,
      }
    case GET_SUBMIT_CASES:
      return {
        ...state,
        permitSubmission: {
          ...state.permitSubmission, // keep old values
          ...payload.data,
          permission: payload?.data?.permission,
        },
      }

    case PERMITDUPLICATECHECK:
      return {
        ...state,
        permitDuplicate: {
          ...state.permitDuplicate, // keep old values
          ...payload.data,
          permission: payload.permission, // update only permission
        },
      }
    case GET_NEW_CASES:
      return {
        ...state,
        permitNewCase: payload.data,
      }
    case GET_PERMISSION_CASES:
      return {
        ...state,
        permissionCases: payload.data,
      }
    case ADMIN_CASE_TIMEINFO:
      return {
        ...state,
        adminCaseTimeInfo: payload.data,
      }
    case GET_CASETIME_INFO_BY_ID:
      return {
        ...state,
        getCaseTimeInfo: payload.data,
        total_records: payload.total_records,
      }
    case CLEAR_CASE_TIME_INFO:
      return {
        ...state,
        getCaseTimeInfo: [],
        total_records: null,
      }
    default:
      return state
  }
}

export default casesReducer
